import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import {
  Sc3FailedMessagesExportSetInitialState,
  Sc3FailedMessagesExportStart,
} from './sc3-failed-messages-export.actions';
import { ListSearchCriteriaFacade } from '../../../../list-search-criteria/list-search-criteria.facade';
import { ListSearchCriteriaType } from '../../../../list-search-criteria/constants/list-search-criteria-type.constant';
import { FailedMessagesExportFacadeInterface, Sc3FailedMessagesListSearchCriteria } from '../../models';
import { ExportDialogComponent } from '../../../../../../ui-kit/export-dialog';

@Injectable({ providedIn: 'root' })
export class Sc3FailedMessagesExportFacade implements FailedMessagesExportFacadeInterface {
  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  startExportToFile(
    reportName: string,
    dialogRef: MatDialogRef<ExportDialogComponent>,
    navigationNeeded: boolean,
  ): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.Sc3FailedMessages)
      .subscribe((searchCriteria: Sc3FailedMessagesListSearchCriteria) => {
        this.store.dispatch(
          new Sc3FailedMessagesExportStart({
            searchCriteria,
            reportName,
            dialogRef,
            navigationNeeded,
          }),
        );
      });
  }

  setInitialState(): void {
    this.store.dispatch(new Sc3FailedMessagesExportSetInitialState());
  }
}
